/** @format */

import Header from "../../components/home/header/header";
import Giftcard from "../../assets/images/Smart house security.png";
import SubmitButton from "../../components/atoms/submitbutton";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { passwordResetSchema } from "../../validations/reset";
import { useState } from "react";
import { MainSection, ImageSection, ResetSection, Input } from "./styles";

type FormData = yup.InferType<typeof passwordResetSchema>;
const Reset = () => {
  const [isloading, setisloading] = useState(false);

  const { register, handleSubmit, formState } = useForm<FormData>({
    resolver: yupResolver(passwordResetSchema),
  });
  const { errors } = formState;

  const resetRequest = (data: any) => {
    setisloading(true);
  };

  return (
    <>
      <Header />
      <MainSection>
        <ImageSection>
          <img src={Giftcard} alt="" />
        </ImageSection>
        <ResetSection>
          <form onSubmit={handleSubmit(resetRequest)}>
            <h2 className="mb-5">Change Password</h2>
            <Input
              autoComplete="password"
              className="p-3"
              {...register("password")}
              type="password"
              placeholder="Password"
              name="password"
              width={"312px"}
            />
            {errors?.password && (
              <p className="text-xs   text-red-600">
                {errors.password?.message}
              </p>
            )}
            <Input
              {...register("confirmPassword")}
              type="password"
              className="p-3"
              placeholder="Confirm Password"
              name="confirmPassword"
              width="312px"
            />
            {errors?.confirmPassword && (
              <p className="text-xs   text-red-600">
                {errors.confirmPassword?.message}
              </p>
            )}

            <SubmitButton value={"Save"} isloading={isloading} width="19.6em" />
          </form>
        </ResetSection>
      </MainSection>
    </>
  );
};

export default Reset;
